<div class="documents-table-wrapper">
  @if (currentRootId || breadcrumbs.length > 0) {
    <div class="breadcrumbs">
      <span (click)="navigateToBreadcrumb(-1)" class="breadcrumb-item clickable">All</span>
      @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index; let isLast = $last) {
        <mat-icon class="breadcrumb-separator" svgIcon="chevron-light"></mat-icon>
        <span
          (click)="navigateToBreadcrumb(i)"
          [class.breadcrumb-item-selected]="isLast"
          class="breadcrumb-item clickable"
          >
          {{ breadcrumb.name }}
        </span>
      }
    </div>
  }

  <table [dataSource]="dataSource" class="documents-table" mat-table>
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef class="text-type-6 !leading-[24px]" mat-header-cell>Name</th>
      <td *matCellDef="let row" mat-cell>
        <div [ngStyle]="getIndentStyle(row?.level)" class="name-cell">
          @if (row?.hasChildren) {
            <mat-icon
              (click)="toggleRow(row); $event.stopPropagation()"
              [ngClass]="{ expanded: isRowExpanded(row) }"
              class="chevron-icon"
              svgIcon="chevron-light"
              />
          }
          @if (!row?.hasChildren) {
            <span class="spacer"></span>
          }

          @if (row?.type === 'folder') {
            <mat-icon class="folder-icon" svgIcon="folder" />
          }

          @if (row?.type === 'document' && row?.hasVersions) {
            <mat-icon class="file-icon">insert_drive_file</mat-icon>
          }

          @if (
            row?.type === 'document' &&
            !row?.hasVersions &&
            (row?.fileType === 'picture' || row?.fileType === 'document') &&
            row?.thumb_url &&
            !hasThumbnailError(row?.id)
            ) {
            <img
              (error)="onThumbnailError($event, row?.id)"
              [alt]="row?.name"
              [src]="row?.thumb_url"
              class="thumbnail-icon"
              />
          }

          @if (
            row?.type === 'document' &&
            !row?.hasVersions &&
            ((row?.fileType !== 'picture' && row?.fileType !== 'document') ||
            !row?.thumb_url ||
            hasThumbnailError(row?.id))
            ) {
            <mat-icon
              class="file-icon"
              >insert_drive_file
            </mat-icon>
          }

          @if (
            row?.type === 'attachment' &&
            (row?.fileType === 'picture' || row?.fileType === 'document') &&
            row?.thumb_url &&
            !hasThumbnailError(row?.id)
            ) {
            <img
              (error)="onThumbnailError($event, row?.id)"
              [alt]="row?.name"
              [src]="row?.thumb_url"
              class="thumbnail-icon"
              />
          }

          @if (
            row?.type === 'attachment' &&
            ((row?.fileType !== 'picture' && row?.fileType !== 'document') ||
            !row?.thumb_url ||
            hasThumbnailError(row?.id))
            ) {
            <mat-icon
              class="file-icon"
              >description
            </mat-icon>
          }

          @if (row?.type !== 'folder' && isPreviewable(row)) {
            <span
              (click)="openDocumentCarousel($event, row)"
              class="text-type-11 clickable document-name"
            >{{ row?.name }}</span>
          }
          @if (row?.type !== 'folder' && !isPreviewable(row)) {
            <span class="text-type-11">{{ row?.name }}</span>
          }
          @if (row?.type === 'folder') {
            <span
              (click)="navigateToFolder(row); $event.stopPropagation()"
              [ngClass]="'text-type-8 clickable folder-name'"
              >{{ row?.name }}</span
              >
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th *matHeaderCellDef class="text-type-6 !leading-[24px] text-right" mat-header-cell>Size</th>
        <td *matCellDef="let row" class="text-type-11 text-right" mat-cell>
          {{ row?.size && !row?.hasVersions ? (row?.size | humanReadableSize) : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="filesVersions">
        <th *matHeaderCellDef class="text-type-6 !leading-[24px] text-center" mat-header-cell>Files/Versions</th>
        <td *matCellDef="let row" class="text-type-11 text-center" mat-cell>
          {{ row?.filesVersions }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastModified">
        <th *matHeaderCellDef class="text-type-6 !leading-[24px] text-right" mat-header-cell>Last modified</th>
        <td *matCellDef="let row" class="text-type-11 text-right" mat-cell>
          {{ row?.lastModified }}
        </td>
      </ng-container>

      <ng-container matColumnDef="menu">
        <th *matHeaderCellDef class="text-type-6 !leading-[24px]" mat-header-cell>&nbsp;</th>
        <td *matCellDef="let row" class="text-type-11" mat-cell>
          @if (!(row?.type === 'document' && row?.hasVersions) && (row?.type !== 'folder' || canEdit)) {
            <mat-icon
              (click)="$event.stopPropagation()"
              [matMenuTriggerFor]="rowMenu"
             
              class="menu-icon"
              >more_horiz
            </mat-icon>
          }
          <mat-menu #rowMenu="matMenu">
            @if (row?.type !== 'folder') {
              <button (click)="download(row)" mat-menu-item>
                <mat-icon>download</mat-icon>
                <span>Download</span>
              </button>
            }
            @if (canEdit) {
              <button (click)="rename(row)" mat-menu-item>
                <mat-icon svgIcon="pencil-outline"></mat-icon>
                <span>Rename</span>
              </button>
            }
            @if (canEdit) {
              <button (click)="delete(row)" mat-menu-item>
                <mat-icon svgIcon="trash"></mat-icon>
                <span>Delete</span>
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
        mat-row
      ></tr>
    </table>

    @if (!dataSource?.length) {
      <div class="no-data text-type-8 mt-[80px]">No data available.</div>
    }
  </div>
  <input
    #fileInputForDocumentUpload
    (change)="onFileSelected($event)"
    accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx, .csv, .zip, .kmz, .kml, .dwg, .dxf, .mp4, .mov, .txt"
    class="hidden"
    multiple="multiple"
    type="file"
    />
